import router from '../router/index'
import axios from 'axios'
export default {
    state: {
        newShippingTest: {},
        newTouristTest: {},
        newSelfServiceCellexTest: {}
    },

    mutations: {
        nullNewShippingTest(state) {
            state.newShippingTest = {}
        },
        selfServiceNewShippingTestFirst(state, credentials) {
            state.newShippingTest = Object.assign({
                interviewDate: credentials.interviewDate,
                caseCode: credentials.caseCode,
                orgCode: credentials.orgCode,
                lastName: credentials.lastName,
                firstName: credentials.firstName,
                passportNo: credentials.passportNo,
                email: credentials.email,
                reportType: 'shipping',
                result: "PENDING",
                formJsonText: Object.assign({
                    patientProfile: credentials.formJsonText.patientProfile,
                    permanentAddress: credentials.formJsonText.permanentAddress,
                    currentAddress: credentials.formJsonText.currentAddress,
                    addressOutside: credentials.formJsonText.addressOutside,
                    fullAddress: credentials.formJsonText.fullAddress

                })
            })
        },

        selfServiceNewShippingTestSecond(state, credentials) {
            state.newShippingTest.formJsonText = Object.assign({
                patientProfile: state.newShippingTest.formJsonText.patientProfile,
                permanentAddress: state.newShippingTest.formJsonText.permanentAddress,
                currentAddress: state.newShippingTest.formJsonText.currentAddress,
                addressOutside: state.newShippingTest.formJsonText.addressOutside,
                travelHistory: credentials.travelHistory,
                exposureHistory: credentials.exposureHistory,
                clinicalInformation: credentials.clinicalInformation

            })
        },

        selfServiceNewTouristTestFirst(state, credentials){
            console.log(credentials)
            state.newTouristTest = Object.assign({
                caseCode: credentials.caseCode,
                orgCode: credentials.orgCode,
                interviewDate: new Date().getTime(),
                lastName: credentials.lastName,
                firstName: credentials.firstName,
                passportNo: credentials.passportNo,
                email: credentials.email,
                reportType: 'tourist',
                result: 'PENDING',
                formJsonText: Object.assign({
                    flightInfo: credentials.formJsonText.flightInfo,
                    personalInfo: credentials.formJsonText.personalInfo,
                    contactInfo: credentials.formJsonText.contactInfo,
                    temporaryAddress: credentials.formJsonText.temporaryAddress,
                    emergencyContactInfo: credentials.formJsonText.emergencyContactInfo,
                    family: credentials.formJsonText.family,
                    quarantinePlace: credentials.formJsonText.quarantinePlace
                })
            })
        },

        selfServiceNewTouristTestSecond(state, credentials){
            state.newTouristTest.formJsonText = Object({
                flightInfo: state.newTouristTest.formJsonText.flightInfo,
                personalInfo: state.newTouristTest.formJsonText.personalInfo,
                contactInfo: state.newTouristTest.formJsonText.contactInfo,
                temporaryAddress: state.newTouristTest.formJsonText.temporaryAddress,
                family: state.newTouristTest.formJsonText.family,
                quarantinePlace: state.newTouristTest.formJsonText.quarantinePlace,
                questionnaire: credentials.questionnaire
            })
        },

        nullNewTouristTest(state){
            state.newTouristTest = {}
        },

        newSelfServiceCellexTestFirst(state, credentials){
            // state.newSelfServiceCellexTest = {
            //     ...state.newSelfServiceCellexTest,
            //     personalInfo: {
            //         firstName: credentials.firstName,
            //         lastName: credentials.lastName,
            //         idNumber: credentials.idNumber,
            //         gender: credentials.gender,
            //         birthDate: credentials.birthDate,
            //         orgCode: credentials.orgCode,
            //         country: credentials.country,
            //         nationality: credentials.nationality,
            //         city: credentials.city,
            //         address: credentials.address,
            //         postalCode: credentials.postalCode,
            //         phone: credentials.phone,
            //         email: credentials.email
            //     }
            // }

        
        }
    },

    actions: {
        selfServiceNewShippingTestFirst({ commit,state  }, credentials) {
            commit('selfServiceNewShippingTestFirst', credentials)
            axios.post(`${process.env.VUE_APP_BASE_URL}/case/`, state.newShippingTest)
                .then(res => {
                    console.log(res)
                    router.push('/selfService/dashboard')
                    commit('nullNewShippingTest')
                })
                .catch(err => {
                    console.log(err)
                })
        },

        selfServiceNewShippingTestSecond({ commit,state }, credentials) {
            commit('selfServiceNewShippingTestSecond', credentials)
            axios.post(`${process.env.VUE_APP_BASE_URL}/case/`, state.newShippingTest)
                .then(res => {
                    console.log(res)
                    router.push('/selfService/dashboard')
                    commit('nullNewShippingTest')
                })
                .catch(err => {
                    console.log(err)
                })
        },

        selfServiceNewTouristTestFirst({commit}, credentials){
            commit('selfServiceNewTouristTestFirst', credentials)
            router.push('second')
        },

        selfServiceNewTouristTestSecond({commit,state}, credentials){
            commit('selfServiceNewTouristTestSecond', credentials)
            axios.post(`${process.env.VUE_APP_BASE_URL}/case/`, state.newTouristTest)
            .then(res => {
                console.log(res)
                router.push('/selfService/dashboard')
                commit('nullNewTouristTest')
            })
            .catch(err => {
                console.log(err)
            })
        },

        newSelfServiceCellexTestFirst({commit, state}, credentials){
            axios.post(`${process.env.VUE_APP_BASE_URL}/case/`, {
                firstName: credentials.firstName,
                lastName: credentials.lastName,
                email: credentials.email,
                orgCode: !!credentials.orgCode ? credentials.orgCode : 'dummyCode',
                passportNo: credentials.idNumber,
                reportType: 'cellex',
                caseCode: '',
                testId: null,
                interviewDate: new Date(),
                result: false,
                formJsonText: null
            })
                .then(res => {
                    console.log(res)
                    router.push({ path: "/index" });
                })
                .catch(err => {
                    console.log(err)
                })
       
        },

        newSelfServiceCellexTestPersonal({commit, state}, credentials){
            
        }
    }
}